<template>
  <transition name="fade" mode="out-in" appear>
    <div v-if="success" class="alert alert-success">
      <slot>
        <p>{{ success }}</p>
      </slot>
    </div>
    <div v-else-if="error" class="alert alert-danger">
      <slot>
        <p>{{ error }}</p>
      </slot>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['success', 'error'],
};
</script>



// WEBPACK FOOTER //
// Alert.vue?07718519